import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21a0a170"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__info" }
const _hoisted_4 = {
  key: 0,
  class: "optional-block"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "images__item__picture" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/empty/skeleton.png",
    alt: "skeleton-card"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]

import { ElSkeleton, ElSkeletonItem } from 'element-plus';
import { SizeSkeletonCard } from '../constants';

interface Props {
  size: SizeSkeletonCard;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailSkeleton',
  props: {
    size: { default: SizeSkeletonCard.X }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_unref(ElSkeleton), {
        animated: "",
        style: {"--el-skeleton-circle-size":"32px","--el-fill-color":"#ebebeb","width":"32px"}
      }, {
        template: _withCtx(() => [
          _createVNode(_unref(ElSkeletonItem), { variant: "circle" })
        ]),
        _: 1
      }),
      _createVNode(_unref(ElSkeleton), {
        animated: "",
        width: "100%",
        height: "17px"
      }, {
        template: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(ElSkeletonItem), {
              variant: "text",
              style: {"width":"100%","height":"17px","--el-fill-color":"#ebebeb"}
            }),
            _createVNode(_unref(ElSkeletonItem), {
              variant: "text",
              style: {"width":"33%","height":"17px","--el-fill-color":"#ebebeb"}
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["images", _ctx.size])
    }, [
      (_ctx.size === _unref(SizeSkeletonCard).M)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
              return _createElementVNode("div", {
                key: item,
                class: "images__item"
              }, _hoisted_6)
            }), 64))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})